//
// Module for the User Subscriptions Setup view
//
rs.module("user/subscriptions/setup",

    [ "common/visibility" ],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors, distributionMethods) {

            var form = $.js(jsSelectors.form);

            var distChannelSelect = form.js(jsSelectors.distChannelSelect);
            var emailDiv = form.js(jsSelectors.emailDiv);

            distChannelSelect.change(distributionMethodChanged);

            // Distribution Method selection changed
            function distributionMethodChanged() {
                visibility.setVisible(emailDiv, distChannelSelect.val() == distributionMethods.email);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);